var _rect, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "#227EFF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 812
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "#227EFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.863,
    y: -135.465,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 240.863 -135.465)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.328,
    y: 394.4,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 139.328 394.4)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.095,
    y: 129.468,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 190.095 129.468)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5601,
    y: 659.332,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 88.5601 659.332)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -74.8367,
    y: 78.7,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -74.8367 78.7)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.492,
    y: 710.1,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 353.492 710.1)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.479,
    y: -2.99841,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 215.479 -2.99841)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 526.866,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 113.944 526.866)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.712,
    y: 261.934,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 164.712 261.934)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.1763,
    y: 791.798,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 63.1763 791.798)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -49.4529,
    y: -53.7661,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -49.4529 -53.7661)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.876,
    y: 577.634,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 378.876 577.634)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -100.221,
    y: 211.166,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -100.221 211.166)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.329,
    y: -110.081,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 373.329 -110.081)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.794,
    y: 419.784,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 271.794 419.784)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.562,
    y: 154.852,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 322.562 154.852)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.026,
    y: 684.716,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 221.026 684.716)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.86157,
    y: 369.016,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 6.86157 369.016)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6294,
    y: 104.084,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 57.6294 104.084)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -43.906,
    y: 633.948,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -43.906 633.948)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.946,
    y: 22.3854,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 347.946 22.3854)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.41,
    y: 552.25,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 246.41 552.25)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.178,
    y: 287.318,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 297.178 287.318)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0132,
    y: -28.3823,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 83.0132 -28.3823)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.5222,
    y: 501.482,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -18.5222 501.482)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2456,
    y: 236.55,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 32.2456 236.55)",
    fill: "#0350BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -69.29,
    y: 766.414,
    width: 123.866,
    height: 123.866,
    rx: 16,
    transform: "rotate(10.8478 -69.29 766.414)",
    fill: "#0350BB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6e0df24a53c754677a039facee4751b9.svg";
export { ForwardRef as ReactComponent };